import { defineMessages } from 'react-intl';

export default defineMessages({
  emptyTableMessage: {
    id: 'General.emptyTableMessage',
    defaultMessage: 'No content here yet',
    description: 'Message to be displayed in an empty tables',
  },
  skholeCourses: {
    id: 'General.skholeCourses',
    defaultMessage: '{serviceNamePossessive} courses',
  },
  defaultPossessiveName: {
    id: 'General.serviceNamePossessive',
    defaultMessage: 'Skhole',
  },
  nextIconAriaLabel: {
    id: 'General.nextIconAriaLabel',
    defaultMessage: 'Next',
  },
  backIconAriaLabel: {
    id: 'General.backIconAriaLabel',
    defaultMessage: 'Previous',
  },
});
